// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var $$Error = require("../../common/Error/Error.bs.js");
var Hooks = require("../../../utils/Hooks.bs.js");
var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Entity = require("../../common/types/Entity.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Sentry = require("../../Sentry.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var $$Promise = require("reason-promise/src/js/promise.bs.js");
var Tooltip = require("../../common/Tooltip.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var ViewStack = require("../../common/ViewStack.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var ChatWindow = require("./ChatWindow.bs.js");
var FeaturesV3 = require("../../featureFlipper/FeaturesV3.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Responsive = require("../../../uikit/reason/helpers/Responsive.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var ApolloHooks = require("reason-apollo-hooks/src/ApolloHooks.bs.js");
var Attachments = require("../../common/Attachments/Attachments.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CurrentUser = require("../../common/CurrentUser/CurrentUser.bs.js");
var QueryParams = require("../../QueryParams.bs.js");
var Types__User = require("../../user/Types__User.bs.js");
var GraphqlTag = require("graphql-tag").default;
var ApolloClient = require("reason-apollo/src/ApolloClient.bs.js");
var Avatar__Jsx3 = require("../../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
var Theme__Color = require("../../common/Theme/Theme__Color.bs.js");
var Buttons__Jsx3 = require("../../../uikit/reason/atoms/Buttons/Buttons__Jsx3.bs.js");
var TANApolloHooks = require("../../utils/apollo/TANApolloHooks.bs.js");
var React$1 = require("linkifyjs/react");
var GraphQLConverter = require("../../common/GraphQLConverter.bs.js");
var User__Components = require("../../user/User__Components.bs.js");
var Js_null_undefined = require("rescript/lib/js/js_null_undefined.js");
var RelativeDateLabel = require("../../common/RelativeDateLabel.bs.js");
var Types__Attachment = require("../../common/types/Types__Attachment.bs.js");
var ConversationAlerts = require("../graphql/ConversationAlerts.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var CssGrid = require("components/CssGrid");
var Colors = require("uikit/styles/colors");
var Conversations__Types = require("../types/Conversations__Types.bs.js");
var Property__Components = require("../../clients/components/Property/Property__Components.bs.js");
var WarningSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/WarningSection__Jsx3.bs.js");
var Conversations__GraphQL = require("../graphql/Conversations__GraphQL.bs.js");
var ConversationInput__Form = require("./ConversationInput__Form.bs.js");
var ConversationMessageArea = require("./ConversationMessageArea.bs.js");
var Conversations__Components = require("./Conversations__Components.bs.js");
var UnsupportedAttachmentsDialog = require("../../common/Attachments/UnsupportedAttachmentsDialog.bs.js");
var ConversationInput__Attachments = require("./ConversationInput__Attachments.bs.js");

function decodeResults(param) {
  return GraphQLConverter.Helpers.decodeRequired("results was None", (function (param) {
                return GraphQLConverter.Helpers.decodeArray((function (i) {
                              return i;
                            }), param);
              }), param);
}

function decodeResponse(param) {
  return GraphQLConverter.Helpers.decodeRequired("conversations was None", (function (conversations) {
                var partial_arg = GraphQLConverter.Helpers.ok(conversations.results);
                return GraphQLConverter.Helpers.run(function (results) {
                              return {
                                      results: results,
                                      pageInfo: conversations.pageInfo
                                    };
                            })(function (param) {
                            return GraphQLConverter.Helpers.flatMap((function (param) {
                                          return GraphQLConverter.Helpers.source(conversations, param);
                                        }), partial_arg, param);
                          });
              }), param);
}

var ppx_printed_query = "query conversations($entityId: ID, $entityType: ContextType)  {\nconversations(filter: {id: $entityId, type: $entityType}, limit: 20, includePublic: true)  {\nresults  {\n..." + Conversations__Types.Conversation.Fragments.ConversationWithoutContext.name + "   \n}\n\npageInfo  {\nhasNext  \nlastCursor  \n}\n\n}\n\n}\n" + Conversations__Types.Conversation.Fragments.ConversationWithoutContext.query;

function parse(value) {
  var value$1 = value["conversations"];
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1["results"];
    var value$3 = value$1["pageInfo"];
    var value$4 = Js_json.decodeObject(value$3);
    var tmp$1;
    if (value$4 !== undefined) {
      var value$5 = Caml_option.valFromOption(value$4);
      var value$6 = Js_dict.get(value$5, "hasNext");
      var field_hasNext = value$6 !== undefined ? Caml_option.valFromOption(value$6) : Js_exn.raiseError("Unexpected GraphQL query response");
      var value$7 = Js_dict.get(value$5, "lastCursor");
      var field_lastCursor;
      if (value$7 !== undefined) {
        var value$8 = Caml_option.valFromOption(value$7);
        field_lastCursor = (value$8 == null) ? undefined : value$8;
      } else {
        field_lastCursor = undefined;
      }
      tmp$1 = {
        hasNext: field_hasNext,
        lastCursor: field_lastCursor
      };
    } else {
      tmp$1 = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    tmp = {
      results: decodeResults(!(value$2 == null) ? Js_array.map((function (value) {
                    return Curry._1(Conversations__Types.Conversation.Fragments.ConversationWithoutContext.parse, value);
                  }), value$2) : undefined),
      pageInfo: tmp$1
    };
  }
  return {
          conversations: decodeResponse(tmp)
        };
}

function json_of_ContextType(value) {
  if (value === "BUYER_NEED") {
    return "BUYER_NEED";
  } else if (value === "RENTAL_NEED") {
    return "RENTAL_NEED";
  } else if (value === "PROPERTY") {
    return "PROPERTY";
  } else if (value === "RENTAL_PROPERTY") {
    return "RENTAL_PROPERTY";
  } else {
    return "BROADCAST_MESSAGE";
  }
}

function make(entityId, entityType, param) {
  return {
          query: ppx_printed_query,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "entityId",
                      entityId !== undefined ? entityId : null
                    ],
                    [
                      "entityType",
                      entityType !== undefined ? json_of_ContextType(entityType) : null
                    ]
                  ])),
          parse: parse
        };
}

function makeWithVariables(variables) {
  var entityId = variables.entityId;
  var entityType = variables.entityType;
  return {
          query: ppx_printed_query,
          variables: Js_dict.fromArray(Js_array.filter((function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    }), [
                    [
                      "entityId",
                      entityId !== undefined ? entityId : null
                    ],
                    [
                      "entityType",
                      entityType !== undefined ? json_of_ContextType(entityType) : null
                    ]
                  ])),
          parse: parse
        };
}

function makeVariables(entityId, entityType, param) {
  return Js_dict.fromArray(Js_array.filter((function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  }), [
                  [
                    "entityId",
                    entityId !== undefined ? entityId : null
                  ],
                  [
                    "entityType",
                    entityType !== undefined ? json_of_ContextType(entityType) : null
                  ]
                ]));
}

function definition_2(graphql_ppx_use_json_variables_fn, entityId, entityType, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray(Js_array.filter((function (param) {
                        return !Js_json.test(param[1], /* Null */5);
                      }), [
                      [
                        "entityId",
                        entityId !== undefined ? entityId : null
                      ],
                      [
                        "entityType",
                        entityType !== undefined ? json_of_ContextType(entityType) : null
                      ]
                    ])));
}

var definition = [
  parse,
  ppx_printed_query,
  definition_2
];

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var GQL = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  json_of_ContextType: json_of_ContextType,
  make: make,
  makeWithVariables: makeWithVariables,
  makeVariables: makeVariables,
  definition: definition,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var Read = ApolloClient.ReadQuery({
      query: ppx_printed_query,
      parse: parse
    });

var include = ApolloClient.WriteQuery({
      query: ppx_printed_query,
      parse: parse
    });

var make$1 = include.make;

function queryResultWithNewConversation(data, newConversation) {
  return {
          conversations: {
            results: Belt_Array.concat([newConversation], data.results),
            pageInfo: {
              hasNext: data.pageInfo.hasNext,
              lastCursor: data.pageInfo.lastCursor,
              __typename: "ConversationsPageInfo"
            },
            __typename: "PaginatedConversationsResult"
          }
        };
}

function queryResultWithNewMessage(conversationId, data, message) {
  var conversationIndex;
  if (conversationId.TAG === /* Existing */0) {
    var id = conversationId._0;
    conversationIndex = Belt_Array.getIndexBy(data.results, (function (v) {
            return v.id === id;
          }));
  } else {
    conversationIndex = undefined;
  }
  if (conversationIndex === undefined) {
    return ;
  }
  var c = data.results[conversationIndex];
  return {
          conversations: {
            results: (Belt_Array.set(data.results, conversationIndex, Object.assign(c, {
                        messages: Belt_Array.concat(c.messages, [message])
                      })), data.results),
            pageInfo: {
              hasNext: data.pageInfo.hasNext,
              lastCursor: data.pageInfo.lastCursor,
              __typename: "ConversationsPageInfo"
            },
            __typename: "PaginatedConversationsResult"
          }
        };
}

var Write_graphqlQueryAST = include.graphqlQueryAST;

var Write = {
  graphqlQueryAST: Write_graphqlQueryAST,
  make: make$1,
  queryResultWithNewConversation: queryResultWithNewConversation,
  queryResultWithNewMessage: queryResultWithNewMessage
};

function useQuery(entityId, entityType, param) {
  return ApolloHooks.useQuery(undefined, Caml_option.some(makeVariables(entityId, Belt_Option.map(entityType, Conversations__GraphQL.EntityType.encode), undefined)), undefined, undefined, undefined, undefined, undefined, undefined, definition);
}

var ConversationsListQuery = {
  decodeResults: decodeResults,
  decodeResponse: decodeResponse,
  GQL: GQL,
  Read: Read,
  Write: Write,
  useQuery: useQuery
};

function fromEntityType(x) {
  if (x >= 4) {
    return /* PublicAndPrivate */0;
  } else {
    return /* PrivateOnly */2;
  }
}

var ReplyPolicy = {
  fromEntityType: fromEntityType
};

var ReadQuery = ApolloClient.ReadQuery({
      query: ppx_printed_query,
      parse: parse
    });

function conversationListQueryOptions(queryObject) {
  return {
          query: GraphqlTag(queryObject.query),
          variables: Js_null_undefined.fromOption(Caml_option.some(queryObject.variables))
        };
}

function useReplyToConversationMutate(conversationId, entityId, entityType, currentUser) {
  var conversationListQuery = make(entityId, Conversations__GraphQL.EntityType.encode(entityType), undefined);
  var readQueryOptions = conversationListQueryOptions(conversationListQuery);
  var update = function (client, mutationResult) {
    var match = Belt_Option.flatMap(Belt_Option.map(Caml_option.nullable_to_opt(client.readQuery(readQueryOptions)), (function (prim) {
                return prim;
              })), (function (q) {
            return q.conversations;
          }));
    var match$1 = mutationResult.data;
    if (match !== undefined && match$1 !== undefined) {
      Belt_Option.map(queryResultWithNewMessage({
                TAG: /* Existing */0,
                _0: conversationId
              }, Caml_option.valFromOption(match), Caml_option.valFromOption(match$1).replyToConversation.message), (function (data) {
              Curry._4(make$1, client, Caml_option.some(conversationListQuery.variables), data, undefined);
            }));
      return ;
    }
    
  };
  var match = TANApolloHooks.useMutation(undefined, undefined, undefined, undefined, update, undefined, Conversations__GraphQL.ReplyToConversationMutation.GQL.definition);
  var replyMutate = match[0];
  return function (param) {
    var text = param.text;
    var match = Belt_Array.partition(param.attachments, Types__Attachment.isImage);
    var files = match[1];
    var images = match[0];
    var variables = Conversations__GraphQL.ReplyToConversationMutation.makeVariables(conversationId, text, images, files, undefined);
    return $$Promise.map($$Promise.mapOk(Curry._6(replyMutate, Caml_option.some(variables), undefined, undefined, undefined, Caml_option.some(Conversations__GraphQL.ReplyToConversationMutation.makeOptimisticResponse(currentUser, text, images, files)), undefined), (function (param) {
                      return param[1];
                    })), (function (x) {
                  if (x.TAG !== /* Ok */0) {
                    return {
                            TAG: /* Error */1,
                            _0: {
                              NAME: "NETWORK_ERROR",
                              VAL: x._0
                            }
                          };
                  }
                  var match = x._0;
                  var response = match.data;
                  if (response !== undefined) {
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              NAME: "Replied",
                              VAL: Caml_option.valFromOption(response)
                            }
                          };
                  }
                  var e = match.errors;
                  if (e !== undefined) {
                    return {
                            TAG: /* Error */1,
                            _0: {
                              NAME: "GRAPHQL_ERRORS",
                              VAL: e
                            }
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: "NO_DATA"
                          };
                  }
                }));
  };
}

function useInitateConversationMutate(entityId, entityType, currentUser) {
  var conversationListQuery = make(entityId, Conversations__GraphQL.EntityType.encode(entityType), undefined);
  var readQueryOptions = conversationListQueryOptions(conversationListQuery);
  var update = function (client, mutationResult) {
    var match = Belt_Option.flatMap(Belt_Option.map(Caml_option.nullable_to_opt(client.readQuery(readQueryOptions)), (function (prim) {
                return prim;
              })), (function (q) {
            return q.conversations;
          }));
    var match$1 = mutationResult.data;
    if (match === undefined) {
      return ;
    }
    if (match$1 === undefined) {
      return ;
    }
    var data = queryResultWithNewConversation(Caml_option.valFromOption(match), Caml_option.valFromOption(match$1).initiateConversation.conversation);
    Curry._4(make$1, client, Caml_option.some(conversationListQuery.variables), data, undefined);
  };
  var match = TANApolloHooks.useMutation(undefined, undefined, undefined, undefined, update, undefined, Conversations__GraphQL.InitiateConversationMutation.GQL.definition);
  var initiateConversationMutate = match[0];
  return function (param) {
    var text = param.text;
    var match = Belt_Array.partition(param.attachments, Types__Attachment.isImage);
    var files = match[1];
    var images = match[0];
    var visibility = param.visibility ? "PUBLIC" : "PRIVATE";
    var variables = Conversations__GraphQL.InitiateConversationMutation.makeVariables(entityId, entityType, visibility, undefined, text, images, files, undefined);
    return $$Promise.map($$Promise.mapOk(Curry._6(initiateConversationMutate, Caml_option.some(variables), undefined, undefined, undefined, Caml_option.some(Conversations__GraphQL.InitiateConversationMutation.makeOptimisticResponse(currentUser, visibility, text, images, files, false)), undefined), (function (param) {
                      return param[1];
                    })), (function (x) {
                  if (x.TAG !== /* Ok */0) {
                    return {
                            TAG: /* Error */1,
                            _0: {
                              NAME: "NETWORK_ERROR",
                              VAL: x._0
                            }
                          };
                  }
                  var match = x._0;
                  var response = match.data;
                  if (response !== undefined) {
                    var conversationId = Belt_Option.map(Caml_option.valFromOption(response).initiateConversation.conversation, (function (conversastion) {
                            return conversastion.id;
                          }));
                    return {
                            TAG: /* Ok */0,
                            _0: {
                              NAME: "InitiatedConversation",
                              VAL: conversationId
                            }
                          };
                  }
                  var e = match.errors;
                  if (e !== undefined) {
                    return {
                            TAG: /* Error */1,
                            _0: {
                              NAME: "GRAPHQL_ERRORS",
                              VAL: e
                            }
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: "NO_DATA"
                          };
                  }
                }));
  };
}

function useForm(mutate, onUnsupportedFileError) {
  var clearAttachments = React.useRef(undefined);
  var form = ConversationInput__Form.useForm({
        text: "",
        attachments: [],
        visibility: /* Private */0
      }, (function (state, param) {
          var reset = param.reset;
          var notifyOnFailure = param.notifyOnFailure;
          $$Promise.get(Curry._1(mutate, state), (function (x) {
                  if (x.TAG !== /* Ok */0) {
                    return Curry._1(notifyOnFailure, undefined);
                  }
                  Curry._1(reset, undefined);
                  var f = clearAttachments.current;
                  if (f !== undefined) {
                    return Curry._1(f, undefined);
                  }
                  
                }));
        }));
  var attachments$p = Attachments.useAttachments((function (attachments) {
          Curry._2(form.updateAttachments, (function (input, attachments) {
                  return {
                          text: input.text,
                          attachments: attachments,
                          visibility: input.visibility
                        };
                }), Belt_List.toArray(attachments));
        }), Belt_List.fromArray(form.input.attachments), onUnsupportedFileError);
  React.useEffect((function () {
          clearAttachments.current = attachments$p.clearAll;
        }), []);
  var submitWithVisiblity = function (visibility) {
    Curry._2(form.updateVisibility, (function (input, visibility) {
            return {
                    text: input.text,
                    attachments: input.attachments,
                    visibility: visibility
                  };
          }), visibility);
    Curry._1(form.submit, undefined);
  };
  return [
          form,
          attachments$p,
          submitWithVisiblity
        ];
}

function markConversationAsRead(currentUser, conversation, isOpen) {
  var markAsRead = Conversations__GraphQL.MarkConversationAsReadMutation.use(undefined);
  React.useEffect((function () {
          var unreadMessage = Belt_Option.flatMap(isOpen ? Utils.List.last(Belt_List.keep(conversation.messages, (function (m) {
                            return Conversations__Types.Message.senderIsUser(m, currentUser.id);
                          }))) : Belt_List.get(conversation.messages, 0), (function (v) {
                  if (Conversations__Types.Conversation.unreadByUser(currentUser.id, v)) {
                    return v;
                  }
                  
                }));
          var match = conversation.id;
          if (match.TAG === /* Existing */0) {
            if (unreadMessage !== undefined) {
              Curry._2(markAsRead, match._0, unreadMessage.id);
            }
            
          }
          
        }), [
        conversation,
        currentUser,
        isOpen
      ]);
}

function ConversationsSection$ConversationMessageArea(props) {
  var focusOnMount = props.focusOnMount;
  var submitButtons = props.submitButtons;
  var attachmentsManager = props.attachmentsManager;
  var form = props.form;
  var focusOnMount$1 = focusOnMount !== undefined ? focusOnMount : false;
  var attachmentsEnabled = FeaturesV3.useFeatureFlipper("ConversationAttachments") === "on";
  var match = React.useState(function () {
        return false;
      });
  var setInputIsFocused = match[1];
  var fallbackRef = React.useRef(null);
  var inputRef = Belt_Option.getWithDefault(props.inputRef, fallbackRef);
  React.useEffect((function () {
          var match = inputRef.current;
          if (focusOnMount$1 && !(match == null)) {
            match.focus({
                  preventScroll: true
                });
          }
          
        }), []);
  var match$1 = attachmentsManager.attachments;
  return React.createElement(ConversationMessageArea.make, {
              isFocused: match[0],
              inputRef: inputRef,
              text: form.input.text,
              onChangeText: (function (text) {
                  Curry._2(form.updateText, (function (input, text) {
                          return {
                                  text: text,
                                  attachments: input.attachments,
                                  visibility: input.visibility
                                };
                        }), text);
                }),
              textInputDisabled: form.submitting,
              onFocus: (function (param) {
                  Curry._1(setInputIsFocused, (function (param) {
                          return true;
                        }));
                }),
              onBlur: (function (param) {
                  Curry._1(setInputIsFocused, (function (param) {
                          return false;
                        }));
                }),
              onKeyDown: (function (e) {
                  if (e.key === "Enter" && e.metaKey && Curry._1(form.valid, undefined)) {
                    return Curry._1(form.submit, undefined);
                  }
                  
                }),
              attachments: Caml_option.some(attachmentsEnabled && match$1.length !== 0 ? React.createElement("div", {
                          className: CssJs.style([CssJs.paddingTop({
                                      NAME: "px",
                                      VAL: 4
                                    })])
                        }, React.createElement(ConversationInput__Attachments.make, {
                              uploads: match$1,
                              onDeleteAttachment: attachmentsManager.delete
                            })) : null),
              buttons: Caml_option.some(attachmentsEnabled ? React.createElement(ViewStack.make, {
                          justifyContent: "spaceBetween",
                          flexDirection: "row",
                          children: Caml_option.some(null)
                        }, React.createElement(ConversationInput__Attachments.AddButton.make, {
                              onAddAttachment: attachmentsManager.add
                            }), React.createElement(ViewStack.make, {
                              alignItems: "center",
                              justifyContent: "flexEnd",
                              flexDirection: "row",
                              children: Caml_option.some(submitButtons)
                            })) : React.createElement(ViewStack.make, {
                          alignItems: "center",
                          justifyContent: "flexEnd",
                          flexDirection: "row",
                          children: Caml_option.some(submitButtons)
                        })),
              placeholder: props.placeholder
            });
}

var ConversationMessageArea$1 = {
  make: ConversationsSection$ConversationMessageArea
};

function ConversationsSection$ConversationsList$Message(props) {
  var belowSlot = props.belowSlot;
  var whiteSpaceVal = props.whiteSpace;
  var visibility = props.visibility;
  var afterMessageSlot = props.afterMessageSlot;
  var message = props.message;
  var afterMessageSlot$1 = afterMessageSlot !== undefined ? afterMessageSlot : (function (param) {
        return null;
      });
  var whiteSpaceVal$1 = whiteSpaceVal !== undefined ? whiteSpaceVal : "normal";
  var belowSlot$1 = belowSlot !== undefined ? belowSlot : (function (param) {
        return null;
      });
  var match = React.useState(function () {
        return false;
      });
  var setHasOverflow = match[1];
  var hasOverflow = match[0];
  var hasOverflowCallback = React.useCallback((function (hasOverflow) {
          Curry._1(setHasOverflow, (function (param) {
                  return hasOverflow;
                }));
        }), [setHasOverflow]);
  var t = message.sender;
  var text = message.text;
  var images = message.images;
  var files = message.files;
  return React.createElement(ViewStack.make, {
              alignItems: "stretch",
              flexDirection: "column",
              children: Caml_option.some(null)
            }, React.createElement(ViewStack.make, {
                  space: Responsive.make({
                        NAME: "px",
                        VAL: 6
                      }, {
                        NAME: "px",
                        VAL: 10
                      }, undefined, undefined, undefined, undefined, undefined),
                  alignItems: "stretch",
                  flexDirection: "row",
                  flexShrink: 0,
                  children: Caml_option.some(null)
                }, React.createElement(User__Components.MaybeAnonymousAvatar.make, {
                      user: message.sender,
                      size: "tiny"
                    }), React.createElement(View__Jsx3.make, {
                      flexDirection: "column",
                      flexGrow: 1,
                      flexBasis: {
                        NAME: "percent",
                        VAL: 0
                      },
                      overflow: "hidden",
                      children: Caml_option.some(null)
                    }, React.createElement(ViewStack.make, {
                          space: {
                            NAME: "px",
                            VAL: 6
                          },
                          alignItems: "center",
                          justifyContent: "flexStart",
                          flexDirection: "row",
                          children: Caml_option.some(null)
                        }, visibility !== undefined && visibility !== "PUBLIC" ? React.createElement(Tooltip.make, {
                                label: "Private conversation",
                                children: React.createElement("span", undefined, React.createElement(Icon__Jsx3.make, {
                                          icon: /* Lock */47
                                        }))
                              }) : null, React.createElement(Text__Jsx3.make, {
                              as_: "div",
                              fontSize: {
                                NAME: "px",
                                VAL: 14
                              },
                              fontWeight: "bold",
                              lineClamp: 1,
                              children: t ? Types__User.label(t._0) : "A TAN User"
                            }), React.createElement(RelativeDateLabel.make, {
                              as_: "div",
                              className: Curry._1(Css.style, {
                                    hd: Css.display("flex"),
                                    tl: {
                                      hd: Css.flexShrink(0),
                                      tl: /* [] */0
                                    }
                                  }),
                              lineClamp: 1,
                              fontSize: {
                                NAME: "px",
                                VAL: 14
                              },
                              date: message.sentAt
                            })), React.createElement(ViewStack.make, {
                          space: "sm",
                          flexDirection: "column",
                          children: Caml_option.some(null)
                        }, React.createElement(Text__Jsx3.WithOverflow.make, {
                              as_: "div",
                              fontSize: Responsive.make({
                                    NAME: "px",
                                    VAL: 14
                                  }, {
                                    NAME: "px",
                                    VAL: 16
                                  }, undefined, undefined, undefined, undefined, undefined),
                              lineHeight: {
                                NAME: "float",
                                VAL: 1.5
                              },
                              whiteSpace: whiteSpaceVal$1,
                              color: Colors.doveGray,
                              lineClamp: props.lineClamp,
                              hasOverflowCallback: hasOverflowCallback,
                              children: text !== undefined ? React.createElement(React$1, {
                                      children: text
                                    }) : null
                            }), images !== undefined ? React.createElement(ChatWindow.ConversationMessageImages.make, {
                                images: images
                              }) : null, files !== undefined ? React.createElement(ChatWindow.ConversationMessageFiles.make, {
                                files: files
                              }) : null), Curry._1(afterMessageSlot$1, hasOverflow))), Curry._1(belowSlot$1, hasOverflow));
}

var Message = {
  make: ConversationsSection$ConversationsList$Message
};

function ConversationsSection$ConversationsList$Replies(props) {
  var replies = props.replies;
  if (Belt_List.length(replies) > 0) {
    return React.createElement(ViewStack.make, {
                width: {
                  NAME: "percent",
                  VAL: 100
                },
                flexGrow: 1,
                children: Caml_option.some(Belt_List.toArray(Belt_List.map(replies, (function (message) {
                                return JsxPPXReactSupport.createElementWithKey(message.id, ConversationsSection$ConversationsList$Message, {
                                            message: message,
                                            whiteSpace: "preLine"
                                          });
                              }))))
              });
  } else {
    return null;
  }
}

var Replies = {
  make: ConversationsSection$ConversationsList$Replies
};

function ConversationsSection$ConversationsList$ReplyInput(props) {
  var currentUser = props.currentUser;
  var conversation = props.conversation;
  var focusOnMount = props.focusOnMount;
  var focusOnMount$1 = focusOnMount !== undefined ? focusOnMount : false;
  var mutate = useReplyToConversationMutate(Conversations__Types.Conversation.idToString(conversation.id), props.entityId, props.entityType, currentUser);
  var match = React.useState(function () {
        return [];
      });
  var setUnsupportedFiles = match[1];
  var match$1 = useForm(mutate, (function (files) {
          Curry._1(setUnsupportedFiles, (function (param) {
                  return files;
                }));
        }));
  var form = match$1[0];
  var submitDisabled = form.submitting || !Curry._1(form.valid, undefined);
  var tmp;
  if (conversation.readOnly) {
    tmp = React.createElement(Conversations__Components.DeactivatedConversationWarning.make, {
          participants: conversation.participants
        });
  } else {
    var match$2 = conversation.visibility;
    var match$3 = conversation.visibility;
    var match$4 = form.status;
    var tmp$1;
    tmp$1 = typeof match$4 === "number" || match$4.TAG !== /* SubmissionFailed */1 ? null : React.createElement($$Error.make, {
            message: "An error ocurred while sending the message"
          });
    tmp = React.createElement(React.Fragment, undefined, React.createElement(Avatar__Jsx3.make, {
              src: Types__User.avatarURL(undefined, undefined, currentUser),
              name: Types__User.name(currentUser),
              size: "tiny"
            }), React.createElement("form", {
              className: Curry._1(Css.style, {
                    hd: Css.width({
                          NAME: "percent",
                          VAL: 100
                        }),
                    tl: /* [] */0
                  }),
              onSubmit: (function (e) {
                  e.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement(ConversationsSection$ConversationMessageArea, {
                  form: form,
                  attachmentsManager: match$1[1],
                  inputRef: props.inputRef,
                  submitButtons: React.createElement(Buttons__Jsx3.PrimaryButton.make, {
                        disabled: submitDisabled,
                        children: Caml_option.some(match$2 === "PUBLIC" ? "Reply publicly" : "Reply privately")
                      }),
                  focusOnMount: focusOnMount$1,
                  placeholder: match$3 === "PUBLIC" ? "Public reply" : "Private reply"
                }), tmp$1));
  }
  return React.createElement(React.Fragment, undefined, React.createElement(UnsupportedAttachmentsDialog.make, {
                  files: match[0],
                  onDismiss: (function (param) {
                      Curry._1(setUnsupportedFiles, (function (param) {
                              return [];
                            }));
                    })
                }), React.createElement(ViewStack.make, {
                  space: Responsive.make({
                        NAME: "px",
                        VAL: 6
                      }, {
                        NAME: "px",
                        VAL: 10
                      }, undefined, undefined, undefined, undefined, undefined),
                  width: {
                    NAME: "percent",
                    VAL: 100
                  },
                  alignItems: "flexStart",
                  flexDirection: "row",
                  flexGrow: 1,
                  children: Caml_option.some(tmp)
                }));
}

var ReplyInput = {
  make: ConversationsSection$ConversationsList$ReplyInput
};

var openConversationLine = Curry._1(Css.style, {
      hd: Css.position("relative"),
      tl: {
        hd: Css.after({
              hd: Css.contentRule({
                    NAME: "text",
                    VAL: " "
                  }),
              tl: {
                hd: Css.position("absolute"),
                tl: {
                  hd: Css.top({
                        NAME: "px",
                        VAL: 45
                      }),
                  tl: {
                    hd: Css.bottom({
                          NAME: "px",
                          VAL: 40
                        }),
                    tl: {
                      hd: Css.left({
                            NAME: "px",
                            VAL: 20
                          }),
                      tl: {
                        hd: Css.width({
                              NAME: "px",
                              VAL: 1
                            }),
                        tl: {
                          hd: Css.backgroundColor(Theme__Color.alto),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

function ConversationsSection$ConversationsList$Conversation(props) {
  var currentUser = props.currentUser;
  var conversation = props.conversation;
  var entityType = props.entityType;
  var entityId = props.entityId;
  var inputRef = props.inputRef;
  var collapsable = props.collapsable;
  var match = React.useState(function () {
        return !collapsable;
      });
  var setOpen = match[1];
  var isOpen = match[0];
  markConversationAsRead(currentUser, conversation, isOpen);
  var replyCount = Belt_List.length(conversation.messages) - 1 | 0;
  var className = Hooks.useResponsive(undefined, Caml_option.some(openConversationLine), undefined, undefined, undefined, undefined, undefined);
  var match$1 = conversation.messages;
  if (!match$1) {
    return null;
  }
  var replies = match$1.tl;
  var message = match$1.hd;
  return React.createElement(View__Jsx3.make, {
              position: "relative",
              className: isOpen ? className : undefined,
              children: Caml_option.some(JsxPPXReactSupport.createElementWithKey(message.id, ConversationsSection$ConversationsList$Message, {
                        message: message,
                        afterMessageSlot: (function (hasOverflow) {
                            if (!collapsable) {
                              return null;
                            }
                            var tmp;
                            var exit = 0;
                            if (hasOverflow) {
                              if (isOpen) {
                                tmp = "View less";
                              } else if (replyCount !== 0) {
                                exit = 1;
                              } else {
                                tmp = "View full message";
                              }
                            } else if (isOpen) {
                              tmp = replyCount !== 0 ? "Hide replies" : "Hide";
                            } else if (replyCount !== 0) {
                              exit = 1;
                            } else {
                              tmp = "Reply";
                            }
                            if (exit === 1) {
                              tmp = replyCount !== 1 ? "View " + (String(replyCount) + " replies") : "View 1 reply";
                            }
                            return React.createElement(View__Jsx3.make, {
                                        justifyContent: "flexStart",
                                        children: Caml_option.some(React.createElement(Buttons__Jsx3.LinkButton.make, {
                                                  onClick: (function (param) {
                                                      Curry._1(setOpen, (function (v) {
                                                              return !v;
                                                            }));
                                                    }),
                                                  children: Caml_option.some(tmp)
                                                }))
                                      });
                          }),
                        lineClamp: isOpen ? undefined : 3,
                        visibility: conversation.visibility,
                        whiteSpace: isOpen ? "preLine" : undefined,
                        belowSlot: (function (hasOverflow) {
                            if (isOpen) {
                              return React.createElement(ViewStack.make, {
                                          pt: {
                                            NAME: "px",
                                            VAL: 20
                                          },
                                          pb: {
                                            NAME: "px",
                                            VAL: 40
                                          },
                                          pl: Responsive.make({
                                                NAME: "px",
                                                VAL: 10
                                              }, {
                                                NAME: "px",
                                                VAL: 50
                                              }, undefined, undefined, undefined, undefined, undefined),
                                          space: {
                                            NAME: "px",
                                            VAL: 20
                                          },
                                          flexDirection: "column",
                                          flexGrow: 1,
                                          children: Caml_option.some(null)
                                        }, React.createElement(ConversationsSection$ConversationsList$Replies, {
                                              replies: replies
                                            }), React.createElement(ConversationsSection$ConversationsList$ReplyInput, {
                                              collapsable: collapsable,
                                              entityType: entityType,
                                              entityId: entityId,
                                              focusOnMount: collapsable && replyCount === 0 && !hasOverflow,
                                              inputRef: collapsable ? undefined : inputRef,
                                              conversation: conversation,
                                              currentUser: currentUser
                                            }));
                            } else {
                              return null;
                            }
                          })
                      }))
            });
}

var Conversation = {
  make: ConversationsSection$ConversationsList$Conversation
};

function ConversationsSection$ConversationsList(props) {
  var inputRef = props.inputRef;
  var conversations = props.conversations;
  var currentUser = props.currentUser;
  var entityType = props.entityType;
  var entityId = props.entityId;
  var collapsable = conversations.length > 1;
  return React.createElement(ViewStack.make, {
              space: {
                NAME: "px",
                VAL: 20
              },
              alignItems: "stretch",
              flexDirection: "column",
              children: Caml_option.some(Belt_Array.map(Utils.$$Array.sort((function (a, b) {
                              var aMessage = Belt_List.get(a.messages, 0);
                              var bMessage = Belt_List.get(b.messages, 0);
                              if (aMessage !== undefined && bMessage !== undefined) {
                                return Caml_obj.compare(bMessage.sentAt, aMessage.sentAt);
                              } else {
                                return 0;
                              }
                            }), conversations), (function (conversation) {
                          return JsxPPXReactSupport.createElementWithKey(Conversations__Types.Conversation.idToString(conversation.id), ConversationsSection$ConversationsList$Conversation, {
                                      collapsable: collapsable,
                                      inputRef: inputRef,
                                      entityId: entityId,
                                      entityType: entityType,
                                      conversation: conversation,
                                      currentUser: currentUser
                                    });
                        })))
            });
}

var ConversationsList = {
  Message: Message,
  Replies: Replies,
  ReplyInput: ReplyInput,
  openConversationLine: openConversationLine,
  Conversation: Conversation,
  make: ConversationsSection$ConversationsList
};

function ConversationsSection$SendMessageButtons(props) {
  var submitWithVisibility = props.submitWithVisibility;
  var submitDisabled = props.submitDisabled;
  switch (props.replyPolicy) {
    case /* PublicAndPrivate */0 :
        return React.createElement(ViewStack.make, {
                    space: "sm",
                    alignItems: "flexEnd",
                    justifyContent: "flexEnd",
                    flexDirection: Responsive.make("column", "row", undefined, undefined, undefined, undefined, undefined),
                    children: Caml_option.some(null)
                  }, React.createElement(Buttons__Jsx3.SecondaryButton.make, {
                        onClick: (function (param) {
                            Curry._1(submitWithVisibility, /* Private */0);
                          }),
                        disabled: submitDisabled,
                        children: "Message Privately"
                      }), React.createElement(Buttons__Jsx3.PrimaryButton.make, {
                        onClick: (function (param) {
                            Curry._1(submitWithVisibility, /* Public */1);
                          }),
                        disabled: submitDisabled,
                        children: "Message Publicly"
                      }));
    case /* PublicOnly */1 :
        return React.createElement(Buttons__Jsx3.PrimaryButton.make, {
                    onClick: (function (param) {
                        Curry._1(submitWithVisibility, /* Public */1);
                      }),
                    disabled: submitDisabled,
                    children: "Send a new public message"
                  });
    case /* PrivateOnly */2 :
        return React.createElement(Buttons__Jsx3.PrimaryButton.make, {
                    onClick: (function (param) {
                        Curry._1(submitWithVisibility, /* Private */0);
                      }),
                    disabled: submitDisabled,
                    children: "Send private message"
                  });
    
  }
}

var SendMessageButtons = {
  make: ConversationsSection$SendMessageButtons
};

function ConversationsSection$NewConversation(props) {
  var mutate = useInitateConversationMutate(props.entityId, props.entityType, props.currentUser);
  var match = React.useState(function () {
        return [];
      });
  var setUnsupportedFiles = match[1];
  var match$1 = useForm(mutate, (function (files) {
          Curry._1(setUnsupportedFiles, (function (param) {
                  return files;
                }));
        }));
  var form = match$1[0];
  var submitDisabled = form.submitting || !Curry._1(form.valid, undefined);
  var match$2 = form.status;
  var tmp;
  tmp = typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1 ? null : React.createElement($$Error.make, {
          message: "An error ocurred while sending the message"
        });
  return React.createElement(React.Fragment, undefined, React.createElement(UnsupportedAttachmentsDialog.make, {
                  files: match[0],
                  onDismiss: (function (param) {
                      Curry._1(setUnsupportedFiles, (function (param) {
                              return [];
                            }));
                    })
                }), React.createElement("form", {
                  className: Curry._1(Css.style, {
                        hd: Css.width({
                              NAME: "percent",
                              VAL: 100
                            }),
                        tl: /* [] */0
                      })
                }, React.createElement(ViewStack.make, {
                      alignItems: "flexEnd",
                      flexDirection: "column",
                      children: Caml_option.some(null)
                    }, React.createElement(ConversationsSection$ConversationMessageArea, {
                          form: form,
                          attachmentsManager: match$1[1],
                          inputRef: props.inputRef,
                          submitButtons: React.createElement(ConversationsSection$SendMessageButtons, {
                                replyPolicy: props.replyPolicy,
                                submitDisabled: submitDisabled,
                                submitWithVisibility: match$1[2]
                              }),
                          placeholder: "Message to " + Types__User.shortLabel(props.entityOwner)
                        }), tmp)));
}

var NewConversation = {
  make: ConversationsSection$NewConversation
};

function ConversationsSection$StartAnotherConversation(props) {
  var currentUser = props.currentUser;
  var mutate = useInitateConversationMutate(props.entityId, props.entityType, currentUser);
  var match = React.useState(function () {
        return [];
      });
  var setUnsupportedFiles = match[1];
  var match$1 = useForm(mutate, (function (files) {
          Curry._1(setUnsupportedFiles, (function (param) {
                  return files;
                }));
        }));
  var form = match$1[0];
  var submitDisabled = form.submitting || !Curry._1(form.valid, undefined);
  var match$2 = form.status;
  var tmp;
  tmp = typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1 ? null : React.createElement($$Error.make, {
          message: "An error ocurred while sending the message"
        });
  return React.createElement(React.Fragment, undefined, React.createElement(UnsupportedAttachmentsDialog.make, {
                  files: match[0],
                  onDismiss: (function (param) {
                      Curry._1(setUnsupportedFiles, (function (param) {
                              return [];
                            }));
                    })
                }), React.createElement(ViewStack.make, {
                  space: Responsive.make({
                        NAME: "px",
                        VAL: 6
                      }, {
                        NAME: "px",
                        VAL: 10
                      }, undefined, undefined, undefined, undefined, undefined),
                  width: {
                    NAME: "percent",
                    VAL: 100
                  },
                  alignItems: "flexStart",
                  flexDirection: "row",
                  flexGrow: 1,
                  children: Caml_option.some(null)
                }, React.createElement(Avatar__Jsx3.make, {
                      src: Types__User.avatarURL(undefined, undefined, currentUser),
                      name: Types__User.name(currentUser),
                      size: "tiny"
                    }), React.createElement("form", {
                      className: Curry._1(Css.style, {
                            hd: Css.width({
                                  NAME: "percent",
                                  VAL: 100
                                }),
                            tl: /* [] */0
                          })
                    }, React.createElement(ViewStack.make, {
                          space: {
                            NAME: "px",
                            VAL: 10
                          },
                          alignItems: "flexEnd",
                          flexDirection: "column",
                          flexGrow: 1,
                          children: Caml_option.some(null)
                        }, React.createElement(ConversationsSection$ConversationMessageArea, {
                              form: form,
                              attachmentsManager: match$1[1],
                              inputRef: props.inputRef,
                              submitButtons: React.createElement(ConversationsSection$SendMessageButtons, {
                                    replyPolicy: props.replyPolicy,
                                    submitDisabled: submitDisabled,
                                    submitWithVisibility: match$1[2]
                                  }),
                              placeholder: "Start a new conversation"
                            }), tmp))));
}

var StartAnotherConversation = {
  make: ConversationsSection$StartAnotherConversation
};

function stringWithDefault($$default) {
  return Curry._1(QueryParams.UseQueryParams.ParamConfigs.fromParamConfig, QueryParams.ParamConfigs.withHiddenDefault(QueryParams.ParamConfigs.stringParam, $$default));
}

var config = Js_dict.fromList({
      hd: [
        "startConversation",
        stringWithDefault("false")
      ],
      tl: /* [] */0
    });

var ParamsConfig = {
  stringWithDefault: stringWithDefault,
  config: config
};

var UseQueryParams = QueryParams.UseQueryParams.Make({
      config: config
    });

var use = UseQueryParams.use;

var QueryParams$1 = {
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  use: use
};

function ConversationsSection$Conversations(props) {
  var refetchConversations = props.refetchConversations;
  var currentUser = props.currentUser;
  var conversations = props.conversations;
  var entityId = props.entityId;
  var entityType = props.entityType;
  var entityOwner = props.entityOwner;
  var userIsOwner = CurrentUser.sameAccountAsCurrentUser(entityOwner, undefined);
  var fallbackRef = React.useRef(null);
  var inputRef = Belt_Option.getWithDefault(props.inputRef, fallbackRef);
  var match = Curry._1(use, undefined);
  var setQueryParams = match[1];
  var queryParams = match[0];
  React.useEffect((function () {
          var match = queryParams.startConversation;
          var shouldFocusInput;
          switch (match) {
            case "1" :
            case "true" :
                shouldFocusInput = true;
                break;
            default:
              shouldFocusInput = false;
          }
          if (shouldFocusInput) {
            Belt_Option.forEach(Caml_option.nullable_to_opt(inputRef.current), (function (el) {
                    Curry._2(setQueryParams, "replaceIn", {
                          startConversation: "false"
                        });
                    el.scrollIntoView({
                          behavior: "auto",
                          block: "start"
                        });
                    el.focus({
                          preventScroll: true
                        });
                  }));
          }
          
        }), []);
  var ownerIsTerminated = entityOwner.membershipStatus === "TERMINATED";
  var terminatedMessage = React.createElement(WarningSection__Jsx3.make, {
        children: "Unable to message as " + (Types__User.label(entityOwner) + " no longer has an active subscription on TAN")
      });
  var canStartAnotherConversation = (entityType === /* BroadcastMessage */4 || Belt_Array.every(conversations, (function (param) {
            return param.readOnly;
          }))) && !userIsOwner && !ownerIsTerminated;
  return React.createElement(CssGrid.Grid, {
              children: Caml_option.some(React.createElement(CssGrid.Cell, {
                        width: 12,
                        widthLg: 9,
                        children: Caml_option.some(null)
                      }, React.createElement(ConversationAlerts.Watcher.make, {
                            onNewAlerts: (function (param) {
                                Curry._2(refetchConversations, undefined, undefined);
                              })
                          }), conversations.length !== 0 ? React.createElement(React.Fragment, undefined, canStartAnotherConversation ? React.createElement("div", {
                                    className: Curry._1(Css.style, {
                                          hd: Css.marginBottom(Css.px(20)),
                                          tl: {
                                            hd: Css.marginTop(Css.px(10)),
                                            tl: {
                                              hd: Css.paddingBottom(Css.px(30)),
                                              tl: {
                                                hd: Css.borderBottom(Css.px(1), Css.solid, Theme__Color.gallery),
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        })
                                  }, React.createElement(ConversationsSection$StartAnotherConversation, {
                                        entityId: entityId,
                                        entityType: entityType,
                                        inputRef: inputRef,
                                        currentUser: currentUser,
                                        replyPolicy: fromEntityType(entityType)
                                      })) : (
                                ownerIsTerminated ? React.createElement(View__Jsx3.make, {
                                        mb: {
                                          NAME: "px",
                                          VAL: 20
                                        },
                                        p: "sm",
                                        children: Caml_option.some(terminatedMessage)
                                      }) : null
                              ), React.createElement(ConversationsSection$ConversationsList, {
                                  entityId: entityId,
                                  entityType: entityType,
                                  currentUser: currentUser,
                                  conversations: conversations,
                                  inputRef: canStartAnotherConversation ? undefined : inputRef
                                })) : (
                          userIsOwner ? React.createElement("div", undefined, "You haven't received any messages about this " + (Entity.Type.toString(entityType) + " yet")) : (
                              ownerIsTerminated ? React.createElement(View__Jsx3.make, {
                                      p: "sm",
                                      children: Caml_option.some(terminatedMessage)
                                    }) : React.createElement(ConversationsSection$NewConversation, {
                                      entityOwner: entityOwner,
                                      entityId: entityId,
                                      entityType: entityType,
                                      currentUser: currentUser,
                                      inputRef: inputRef,
                                      replyPolicy: fromEntityType(entityType)
                                    })
                            )
                        )))
            });
}

var Conversations = {
  QueryParams: QueryParams$1,
  make: ConversationsSection$Conversations
};

function ConversationsSection(props) {
  var onClickContactRef = props.onClickContactRef;
  var entityType = props.entityType;
  var entityId = props.entityId;
  var inputRef = React.useRef(null);
  var onClickContact = function (param) {
    var e = inputRef.current;
    if (!(e == null)) {
      e.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
      return e.focus({
                  preventScroll: true
                });
    }
    
  };
  if (onClickContactRef !== undefined) {
    onClickContactRef.current = onClickContact;
  }
  var currentUser = CurrentUser.useCurrentUser(undefined);
  var match = useQuery(entityId, entityType, undefined);
  var full = match[1];
  var match$1 = currentUser.user;
  var data = full.data;
  var tmp;
  if (data !== undefined) {
    if (match$1 !== undefined) {
      if (full.error !== undefined) {
        tmp = React.createElement("div", undefined, "An error occurred. Please refresh or try again later...");
      } else {
        var conversations = Caml_option.valFromOption(data).conversations;
        if (conversations.TAG === /* Ok */0) {
          tmp = React.createElement(ConversationsSection$Conversations, {
                entityOwner: props.entityOwner,
                entityType: entityType,
                entityId: entityId,
                inputRef: inputRef,
                conversations: conversations._0.results,
                currentUser: match$1,
                refetchConversations: full.refetch
              });
        } else {
          Sentry.captureErrorMessage("error decoding conversations response", true, true, "ConversationsSection.res", 1069, Caml_option.some(conversations._0), undefined, undefined);
          tmp = React.createElement($$Error.make, {
                message: "An error occurred. Please refresh or try again later..."
              });
        }
      }
    } else {
      tmp = null;
    }
  } else {
    tmp = full.loading ? null : React.createElement("div", undefined, "An error occurred. Please refresh or try again later...");
  }
  return React.createElement(CssGrid.Cell, {
              width: 12,
              widthLg: 9,
              children: Caml_option.some(null)
            }, React.createElement(Property__Components.SectionHeader.make, {
                  id: "conversations",
                  children: "Conversations"
                }), tmp);
}

var View;

var $$Text;

var Buttons;

var Responsive$1;

var Conversation$1;

var User;

var ConversationMessageForm;

var make$2 = ConversationsSection;

exports.View = View;
exports.$$Text = $$Text;
exports.Buttons = Buttons;
exports.Responsive = Responsive$1;
exports.Conversation = Conversation$1;
exports.User = User;
exports.ConversationsListQuery = ConversationsListQuery;
exports.ReplyPolicy = ReplyPolicy;
exports.ConversationMessageForm = ConversationMessageForm;
exports.ReadQuery = ReadQuery;
exports.conversationListQueryOptions = conversationListQueryOptions;
exports.useReplyToConversationMutate = useReplyToConversationMutate;
exports.useInitateConversationMutate = useInitateConversationMutate;
exports.useForm = useForm;
exports.markConversationAsRead = markConversationAsRead;
exports.ConversationMessageArea = ConversationMessageArea$1;
exports.ConversationsList = ConversationsList;
exports.SendMessageButtons = SendMessageButtons;
exports.NewConversation = NewConversation;
exports.StartAnotherConversation = StartAnotherConversation;
exports.Conversations = Conversations;
exports.make = make$2;
/* Read Not a pure module */
